import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { configureMoyaAuth } from '@moya/auth/vue';
import { createPlatformShellPlugin } from '@moya/platform-shell-sdk/vue';
import App from './App.vue';
import router from './router';
import './assets/main.css';

configureMoyaAuth({
  ssoPortalUrl: 'https://login.moyasolutions.com',
  appId: 'admin-portal',
  tokenKey: 'token',
  userKey: 'user',
});

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(createPlatformShellPlugin({
  appId: 'admin-portal',
  appName: 'Admin Portal',
  apiUrl: import.meta.env.VITE_IDENTITY_API_URL || 'https://identity.moyasolutions.com/api/v1',
  portalUrl: import.meta.env.VITE_SSO_PORTAL_URL || 'https://login.moyasolutions.com',
  autoRecordAccess: true,
}));

app.mount('#app');
